module.exports = __webpack_public_path__ + "img/1_029.08840d26.jpg";